import Skeleton from 'react-loading-skeleton'

const EventLoading = () => {
  return (
    <div style={{ width: '-webkit-fill-available', marginBottom: '20px' }}>
      <Skeleton height={195} style={{ marginBottom: '5px' }} />
      <Skeleton height={20} count={2} style={{ marginBottom: '5px' }} />
      <Skeleton height={20} count={4} />
    </div>
  )
}

export default EventLoading
